import { render, staticRenderFns } from "./noticias-web.html?vue&type=template&id=e2c9cb2c&scoped=true&"
import script from "./noticias-web.ts?vue&type=script&lang=ts&"
export * from "./noticias-web.ts?vue&type=script&lang=ts&"
import style0 from "./noticias-web.scss?vue&type=style&index=0&id=e2c9cb2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c9cb2c",
  null
  
)

export default component.exports